import React, {Component} from 'react'
import {constants} from '../constants';

import Utility from '../utility'
import Profiles from '../component/profiles'
import Sidebar from './sidebar';
import {colors} from './colors';
import utility from "../utility";


let initialState = {
    da: "",
    db: "",
    dc: "",
    product: "Profil 1",
    productUrl: constants.IMG_URL + "t1.png",
    crossSlope: "",
    crossSlopeMM: "",
    crossSlopeDeg: "",
    runninMeter: "",
    cuttingLength: "3m",
    sheetThickness: "1,5mm",
    bracketSpace: "0,5m",
    color: "Pulver Sonderfarbe RAL 1001 beige",
    type: "Aussenecke",
    anzahl: 0,
    winkel: 0,
    menge: 0,
    links: 0,
    currentProduct: 0,
    productId:0,
    editUpdated:false
};

export default class Standard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            da: "",
            db: "",
            dc: "",
            product: "Profil 1",
            productUrl: constants.IMG_URL + "t1.png",
            crossSlope: "",
            crossSlopeMM: "",
            crossSlopeDeg: "",
            runninMeter: "",
            cuttingLength: "3m",
            sheetThickness: "1,5mm",
            bracketSpace: "0,5m",
            color: "Pulver Sonderfarbe RAL 1001 beige",
            type: "Aussenecke",
            anzahl: 0,
            winkel: 0,
            menge: 0,
            links: 0,
            products: [
                {
                    name: "Profil 1",
                    url: constants.IMG_URL + "t1.png"
                },
                {
                    name: "Profil 2",
                    url: constants.IMG_URL + "t2.png"
                },
                {
                    name: "Profil 3",
                    url: constants.IMG_URL + "t3.png"
                },
                {
                    name: "Profil 4",
                    url: constants.IMG_URL + "t4.png"
                },
                {
                    name: "Profil 5",
                    url: constants.IMG_URL + "t5.png"
                },
            ],
            currentProduct: 0,
            productId:0,
            editUpdated:false
        }

        this.onChange = this.onChange.bind(this);
        this.showCard = this.showCard.bind(this);
        this.select = this.select.bind(this);
        this.sendValue = this.sendValue.bind(this);
        this.resetStandard = this.resetStandard.bind(this);
        this.changeModelValues = this.changeModelValues.bind(this);
    }

    componentDidMount() {
        window.currentEquipment="profil"+(this.state.currentProduct+1); //set initial
    }

    componentDidUpdate(){
        if(this.props.editId!==false && !this.state.editUpdated){
            let currentState=utility.objectCopy(this.state),
                newState={...currentState,...this.props.edit};
            newState.currentProduct=this.props.edit.productId;
            newState.editUpdated=true;
            this.setState({...newState})
        }
    }

    onChange(e, type = false, val = false) {
        let element = e.target,
            newObject={},
            suffix = "";
        suffix = element ? element.getAttribute('data-suffix') : ""
        val = val ? val : element.value;

        type = type ? type : element.getAttribute('data-type');

        //degree/mm change
        if(type === 'crossSlopeMM'){
            newObject['crossSlopeDeg']=utility.mmToDegree(val,this.state.db);
        }else if(type === 'crossSlopeDeg'){
            newObject['crossSlopeMM']=utility.degreeToMM(val,this.state.db);
        }else if(type === 'da'){
            this.changeModelValues("a",val)
        }else if(type === 'db'){
            this.changeModelValues("b",val)
        }else if(type === 'dc'){
            this.changeModelValues("c",val)
        }

        if (suffix) {
            val += suffix;
        }
        newObject[type]= val;

        if (type) {
            this.setState(newObject);
        }
    }

    changeModelValues(type,val) {
        window.drawValues[window.currentEquipment][type] = parseInt(val);
    }


    showCard(e) {
        let element = e.target,
            target = element.getAttribute('data-target');
        document.querySelector(target).classList.toggle('show');
    }

    select(e, type = "equipment") {
        let element = e.target;
        if (element.nodeName === "IMG") { //check clicked tag
            element = element.closest('div');
        }
        let url = element.children[0].src,
            name = element.getAttribute('data-name'),
            active = parseInt(element.getAttribute('data-key')),
            activeKey = "currentEquipment";

        if (type === "product") {
            activeKey = "currentProduct";
            window.currentEquipment="profil"+(active+1);
        }

        if (name) {
            this.setState({[type]: name, [type + "Url"]: url, [activeKey]: active,productId:active});
        }
    }

    sendValue(e) {
        e.preventDefault();
        let d = Utility.objectCopy(this.state);
        delete d['products'];
        delete d['equipments'];
        this.props.save(d, "standard",true,this.props.editId); //data,type,isArray,edit
        //reset state
        this.setState(initialState);
        this.props.resetEdit();
        return this.props.history.push('/');
    }

    resetStandard(){
        //reset state
        this.setState(initialState);
        this.props.resetEdit();
    }

    render() {
        return (
            <React.Fragment>
                <div className="content-side col-lg-8 col-md-12 col-sm-12">
                    <div className="profiles">
                        <Profiles colors={colors} save={this.sendValue} id={this.props.id} edit={this.props.edit} editId={this.props.editId} deg={this.state.crossSlopeDeg}
                                  active={this.state.currentProduct} products={this.state.products} mm={this.state.crossSlopeMM}
                                  change={this.onChange} showCard={this.showCard} select={this.select}/>
                    </div>
                </div>
                <Sidebar resetEdit={this.resetStandard} proxyClick={this.props.proxyClick} id={this.props.id} type="standard" data={this.state}
                         name={"Standard Nr." + this.props.id}/>
            </React.Fragment>
        )
    }
}
